exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bo-overlay{position:absolute;z-index:999999;top:0;left:0;bottom:0;right:0;background:rgba(0,0,0,.5);display:none}.bo-overlay.show{display:flex!important;justify-content:center;align-items:center;flex-direction:column}.bo-overlay h3{margin-top:15px}.bo-overlay .fa{font-size:50px;color:#d23a2a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!./components/LoadingOverlay/_loadingOverlay.css
// module id = 1108
// module chunks = 4